import OutsideClickHandlerInner from 'react-outside-click-handler'
import { interopDefault } from './interopDefault'

export const OutsideClickHandler = interopDefault(OutsideClickHandlerInner)
